import { PropsWithChildren } from "react";

import Breadcrumbs, { useBreadcrumbs } from "@design-system/Breadcrumbs/Breadcrumbs";
import { Header } from "@design-system/Header/Header";

type Props = PropsWithChildren;

export const PortalHeader = ({ children }: Props) => {
  const breadcrumbs = useBreadcrumbs();
  
  if (breadcrumbs.length <= 1 && !children) {
    return null;
  }

  return (
    <Header>
      <Header.Slot>
        <Breadcrumbs />
      </Header.Slot>
      {children && <Header.Slot>{children}</Header.Slot>}
    </Header>
  );
};
